import React, { createContext, useRef, useState } from "react";
import PropTypes from "prop-types";

export const FilterPanelContext = createContext(null);

export const FilterPanelProvider = ({ children }) => {
  const [expandAllTrigger, setExpandAllTrigger] = useState(0);
  const [allExpanded, setAllExpanded] = useState(false);
  const panelCallbacks = useRef(new Map());

  const registerPanel = (sectionKey, updateCallback) => {
    panelCallbacks.current.set(sectionKey, updateCallback);
  };

  const unregisterPanel = (sectionKey) => {
    panelCallbacks.current.delete(sectionKey);
  };

  const expandAll = () => {
    panelCallbacks.current.forEach((callback, sectionKey) => {
      callback(false); // false = expanded
    });
    setAllExpanded(true);
    setExpandAllTrigger((prev) => prev + 1);
  };

  const collapseAll = () => {
    panelCallbacks.current.forEach((callback, sectionKey) => {
      callback(true); // true = collapsed
    });
    setAllExpanded(false);
    setExpandAllTrigger((prev) => prev + 1);
  };

  const toggleExpandCollapseAll = () => {
    if (allExpanded) {
      collapseAll();
    } else {
      expandAll();
    }
  };

  return (
    <FilterPanelContext.Provider
      value={{
        expandAllTrigger,
        allExpanded,
        registerPanel,
        unregisterPanel,
        expandAll,
        collapseAll,
        toggleExpandCollapseAll,
      }}
    >
      {children}
    </FilterPanelContext.Provider>
  );
};

FilterPanelProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
